import { render, staticRenderFns } from "./Informational.vue?vue&type=template&id=a4edf624"
import script from "./Informational.vue?vue&type=script&lang=js"
export * from "./Informational.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports